module.exports = __webpack_public_path__ + "img/cardimg.ecb15723.png";